import React from 'react';
import MultiSelectList from '../../../Elements/MultiSelectList';
import PricingDetailService from '../../../Services/PricingDetailService';
import PricingService from '../../../Services/PricingService';
import CopyPricingItem from '../../../Domain/CopyPricingItem';
import EligiblePricingItem from '../../../Domain/EligiblePricingItem';

export default class PricingDetailCountrySelector extends React.Component {
  static defaultProps = {
    clickOnCancel: () => {
      alert('Empty function');
    },
    pricingDetailId: 0
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <MultiSelectList
        title={`Copy Pricings ${this.props.pricingDetailId}`}
        clickOnCancel={this.props.clickOnCancel}
        onSaveFunction={PricingDetailService.CopyPricings}
        requestItem={new CopyPricingItem(this.props.pricingDetailId)}
        serviceFunction={PricingService.GetEligiblePricingList}
        itemType={EligiblePricingItem}
        convertDBItemsFunction={PricingService.ConvertEligiblePricingDBItem}
        searchItem={this.props.pricingDetailId}
        submitButtonText='Start Copying'
      />
    );
  }
}
